import { useContext } from 'react';
import { StockContext } from './StockContext';
export const useStockContext = () => {
    const stockContext = useContext(StockContext);
    if (stockContext === undefined) {
        throw new Error('useStockContext must be used within a StockContext Provider');
    }
    return stockContext;
};
